import React from "react";
import styled, { useTheme } from "styled-components";
import { Box } from "../Box";
import { Flex } from "../Flex";
import { Text } from "../Text";
const isIndented = (name, indentedItems) => {
    if (indentedItems.length === 0)
        return false;
    return indentedItems.indexOf(name) >= 0;
};
const CapitalizedText = styled(Text) `
  text-transform: capitalize;
  font-size: 1;
`;
export const ChartToolTip = (props) => {
    var _a;
    const { colors: { chartColors }, } = useTheme();
    const { colors = [], defaultColor = chartColors.toolTipDefaultColor, indentedLabels = [], payload: tooltipData, units, labelFormatter, } = props;
    if (!tooltipData || tooltipData.length === 0)
        return null;
    const title = (_a = tooltipData[0]) === null || _a === void 0 ? void 0 : _a.payload.name;
    return (React.createElement(Box, { backgroundColor: chartColors.toolTipBackground, border: 1, borderColor: chartColors.toolTipBorder, borderRadius: 1, "data-testid": "ChartToolTip", opacity: 0.9, p: 1 },
        React.createElement(Text, { fontSize: 1, fontWeight: "bold", fontFamily: "bold" }, labelFormatter ? labelFormatter(title) : title),
        React.createElement(Box, null, tooltipData.map((data, idx) => {
            const { name, dataKey, payload: coords } = data;
            return (React.createElement(Flex, { alignItems: "center", flexDirection: "row", key: idx, marginLeft: isIndented(name, indentedLabels) ? "28px" : 1 },
                !isIndented(name, indentedLabels) && (React.createElement(Box, { backgroundColor: colors[idx] || defaultColor, border: 1, borderColor: colors[idx] || defaultColor, height: 2, mr: 1, width: 2 })),
                React.createElement(CapitalizedText, null,
                    name,
                    ":"),
                React.createElement(Text, { fontSize: 1, pl: 1, fontWeight: "bold" },
                    coords[dataKey],
                    units && (React.createElement("span", null,
                        "\u00A0",
                        units)))));
        }))));
};
